import { UnavailableReason } from '@/types/appointment';

/**
 * O que o cliente lê quando não há horário. Uma frase por motivo, em vez de um
 * "nenhum horário disponível" que serve para tudo.
 */
export const UNAVAILABLE_REASON_COPY: Record<
  UnavailableReason,
  { title: string; description: string }
> = {
  CUSTOM_DURATION: {
    title: 'Serviço sob medida',
    description:
      'O tempo deste serviço é combinado caso a caso. Fale com o prestador para marcar.',
  },
  NO_GRID: {
    title: 'Horários ainda não definidos',
    description: 'O prestador ainda não marcou em quais dias e horários atende.',
  },
  PAUSED: {
    title: 'Agenda pausada',
    description:
      'Este prestador pausou a agenda por tempo indeterminado. Tente mais para frente.',
  },
  NO_SLOTS_IN_RANGE: {
    title: 'Sem horários neste período',
    description:
      'Todas as vagas dos próximos dias já foram preenchidas. Tente mais para frente.',
  },
};
